import React, { FC, memo } from "react";
import { Text } from "@lookiero/sty-psp-ui";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { Header } from "../Header";
import { ButtonIconPlaceholder } from "../buttonIconPlaceholder/ButtonIconPlaceholder";

interface HeaderProps {
  readonly title: string;
  readonly onClose: () => void;
}

const CheckoutHeader: FC<HeaderProps> = ({ title, onClose }) => (
  <Header testID="checkout-header">
    <ButtonIconPlaceholder />
    <Text ellipsizeMode="tail" level={3} numberOfLines={1} style={{ flexShrink: 1 }} variant="action">
      {title}
    </Text>
    <ButtonIcon name="close" testID="close-button-icon" onPress={onClose} />
  </Header>
);

const MemoizedCheckoutHeader = memo(CheckoutHeader);

export { MemoizedCheckoutHeader as CheckoutHeader };
